import React from "react";

import Label from "../../common/components/Label";
import { RECOMMENDABLE_TYPE } from "../constants";


class UserProvided extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: RECOMMENDABLE_TYPE.BOND
        };
    }

    render() {
        return <div>
            <div>
                What are you recommending?
            </div>

            <div style={{margin: "20px 0 20px 20px"}}>

                <div style={{marginBottom: 10}}>
                    <Label>
                        <input
                            className="x-select-bond"
                            type="radio"
                            value={RECOMMENDABLE_TYPE.BOND}
                            checked={this.state.type === RECOMMENDABLE_TYPE.BOND}
                            onChange={() => this.setState({type: RECOMMENDABLE_TYPE.BOND})}
                        />
                        &nbsp;A specific missing Bond
                    </Label>
                </div>

                <div style={{marginBottom: 10}}>
                    <Label>
                        <input
                            className="x-select-issuer"
                            type="radio"
                            value={RECOMMENDABLE_TYPE.ISSUER}
                            checked={this.state.type === RECOMMENDABLE_TYPE.ISSUER}
                            onChange={() => this.setState({type: RECOMMENDABLE_TYPE.ISSUER})}
                        />
                        &nbsp;A missing Issuer
                    </Label>
                </div>

            </div>

            <div className="pure-control-group">
                <Label>
                    {this.state.type === RECOMMENDABLE_TYPE.BOND ?
                        "Enter an ISIN" :
                        "Please supply any ISIN issued by the issuer. We will use this to look up the issuer details."
                    }
                </Label>
                <input className="x-add-missing-input" ref="input" placeholder="Specify ISIN" />
            </div>

            <div style={{marginLeft: "11em"}}>
                <input className="x-add-missing-submit pure-button pure-button-primary" type="button" value="Use This" onClick={() => {
                    const value = this.refs.input.value;
                    this.props.onChange({
                        instrumentId: value,
                        name: value,
                        asset_id: value,
                        recommendableType: this.state.type,
                        userProvided: true
                    });
                }}/>
            </div>
        </div>;
    }
}

export default UserProvided;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/UserProvided.js
 **/